/**
 * OnyxStack Theme JS
 * Cart, product interactions, header scroll, accordion
 */

document.addEventListener('DOMContentLoaded', () => {

  // --- Sticky header scroll effect ---
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Mobile menu toggle ---
  const mobileToggle = document.querySelector('.mobile-toggle');
  const headerNav = document.querySelector('.header-nav');
  if (mobileToggle && headerNav) {
    mobileToggle.addEventListener('click', () => {
      headerNav.classList.toggle('mobile-open');
      mobileToggle.classList.toggle('active');
    });
  }

  // --- Product variant selectors ---
  document.querySelectorAll('.variant-option').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-option').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // --- Quantity selector ---
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    const minus = selector.querySelector('[data-qty="minus"]');
    const plus = selector.querySelector('[data-qty="plus"]');

    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // --- Product detail accordion ---
  document.querySelectorAll('.product-detail-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.product-detail-item');
      item.classList.toggle('open');
    });
  });

  // --- Product thumbnails ---
  document.querySelectorAll('.product-thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = gallery.querySelector('.product-main-image img');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // --- Add to cart (Shopify AJAX API) ---
  const addToCartForms = document.querySelectorAll('[data-add-to-cart]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        const data = await response.json();

        if (response.ok) {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        } else {
          btn.textContent = data.description || 'Error';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // --- Update cart count in header ---
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (err) {}
  }

  // --- Cart item quantity update ---
  document.querySelectorAll('.cart-qty-update').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = btn.dataset.line;
      const qty = btn.dataset.qty;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: parseInt(qty) })
        });
        window.location.reload();
      } catch (err) {}
    });
  });

  // --- Scroll reveal (intersection observer) ---
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(el => observer.observe(el));
  }

});
